import React from 'react';
import html from '../../../Icon/iconfinder_badge-html-5_317755.png'
import css from '../../../Icon/iconfinder_badge-css-3_317756.png'
import JavaScript from '../../../Icon/js.png'
import react from '../../../Icon/iconfinder_React.js_logo_1174949.png'
import firebase from '../../../Icon/iconfinder_google_firebase_1175544.png'
import mongodb from '../../../Icon/mongodb.png'
import redux from '../../../Icon/redux.png'

import './Skills.css'
const Skills = () => {
    return (
        <div className='pt-5 mt-5 pb-5 mb-5'>
           <h2 className="text-center" style={{ color: '#46475c'}}><b>Skills! What I know</b></h2>
           <div className="skills-icon mt-5">
               <div className='row d-flex justify-content-center align-items-center w-100'>
                   <div className='text-center'>
                    <img className='mx-4 my-2' src={html} alt=""/>
                    <figcaption>HTML5</figcaption>
                   </div>
                   <div className='text-center'>
                    <img className='mx-4 my-2' src={css} alt=""/>
                    <figcaption>CSS3</figcaption>
                   </div>
                   <div className='text-center'>
                    <img className='mx-4 my-2' src={JavaScript} alt=""/>
                    <figcaption>JavaScript</figcaption>
                   </div>
                   <div className='text-center'>
                    <img className='mx-4 my-2' src={react} alt=""/>
                    <figcaption>React</figcaption>
                   </div>
                   <div className='text-center'>
                    <img className='mx-4 my-2' src={firebase} alt=""/>
                    <figcaption>Firebase</figcaption>
                   </div>
                   <div className='text-center'>
                    <img className='mx-4 my-2' src={redux} alt=""/>
                    <figcaption>Redux</figcaption>
                   </div>
               </div>
               
               {/* <img src={html} alt=""/>
               <img src={css} alt=""/>
               <img src={JavaScript} alt=""/>
               <img src={react} alt=""/>
               <img src={firebase} alt=""/>
               <img src={redux} alt=""/> */}
           </div>
        </div>
    );
};

export default Skills;